module.exports = __webpack_public_path__ + "img/qrcode.212a95c8.png";